import { Call } from "@snubes/snubes-types";

export const calculateAverageScore = (call: Call): number | null => {
  if (!call.scorecards) return null;

  const scorecards = Object.values(call.scorecards);
  if (scorecards.length === 0) return null;

  const percentages = scorecards.map((scorecard) => {
    if (scorecard.maxScore === 0) return 0;
    return scorecard.totalScore / scorecard.maxScore;
  });

  const average =
    percentages.reduce((sum, pct) => sum + pct, 0) / percentages.length;

  return Math.round(average * 100);
};
